/**
 * Newsletter popup: opens once after a delay, remembers dismissal, and swaps to
 * the discount code after a successful signup. Markup and settings come from
 * snippets/newsletter-popup.liquid.
 */
(function () {
  var dialog = document.querySelector('[data-newsletter-popup]');
  if (!dialog) return;

  var SUBSCRIBED = 'newsletterPopup:subscribed';
  var SNOOZED_UNTIL = 'newsletterPopup:snoozedUntil';
  var PENDING = 'newsletterPopup:pending';

  function read(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (e) {
      /* Private windows and blocked site data throw; the popup still works, it just can't remember. */
    }
  }

  var delay = (Number(dialog.dataset.delay) || 8) * 1000;
  var snoozeMs = (Number(dialog.dataset.snoozeDays) || 7) * 24 * 60 * 60 * 1000;

  var signup = dialog.querySelector('[data-newsletter-signup]');
  var success = dialog.querySelector('[data-newsletter-success]');
  var successHeading = dialog.querySelector('[data-newsletter-success-heading]');
  var form = dialog.querySelector('[data-newsletter-form]');
  var errorEl = dialog.querySelector('[data-newsletter-error]');
  var submit = form.querySelector('[type="submit"]');
  var copyButton = dialog.querySelector('[data-newsletter-copy]');
  var subscribed = false;

  function showSuccess() {
    subscribed = true;
    write(SUBSCRIBED, '1');
    write(PENDING, null);
    signup.hidden = true;
    success.hidden = false;
    present();
    successHeading.focus();
  }

  function present() {
    if (dialog.open) return;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
  }

  /* Don't steal a click from someone mid-form: track the last time they typed into or
     focused a field anywhere on the page, including just after they've moved on from one
     (the gap between blurring a field and clicking Submit). */
  var lastFormInteraction = 0;
  var FORM_GRACE_MS = 4000;

  function noteFormInteraction(event) {
    if (event.target.closest && event.target.closest('form')) lastFormInteraction = Date.now();
  }
  document.addEventListener('focusin', noteFormInteraction, true);
  document.addEventListener('input', noteFormInteraction, true);

  function isEditingForm() {
    var el = document.activeElement;
    if (el && el.closest && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) && el.closest('form')) return true;
    return Date.now() - lastFormInteraction < FORM_GRACE_MS;
  }

  /* Wait out the cart drawer, search, or any other modal instead of stacking on it, and
     wait out a shopper who is still filling out a form, such as the riser configurator,
     instead of popping up over their next click. */
  function openWhenClear(deadline) {
    if (document.querySelector('dialog[open]') || isEditingForm()) {
      if (Date.now() < deadline) window.setTimeout(function () { openWhenClear(deadline); }, 2000);
      return;
    }
    present();
  }

  dialog.addEventListener('close', function () {
    document.documentElement.style.overflow = '';
    if (!subscribed) write(SNOOZED_UNTIL, String(Date.now() + snoozeMs));
  });

  dialog.querySelectorAll('[data-newsletter-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      dialog.close();
    });
  });

  /* A click on the backdrop lands on the dialog element itself, not on the panel inside it. */
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    errorEl.hidden = true;
    submit.disabled = true;

    window
      .fetch(form.action, {
        method: 'POST',
        body: new window.FormData(form),
        credentials: 'same-origin',
      })
      .then(function (response) {
        if (response.url.indexOf('customer_posted=true') !== -1) {
          showSuccess();
          return;
        }

        /* Shopify sent us to a captcha challenge (or anything else unexpected). Let the browser
           submit the form normally; the page reloads and we pick up again from ?customer_posted. */
        write(PENDING, '1');
        form.submit();
      })
      .catch(function () {
        errorEl.hidden = false;
        submit.disabled = false;
      });
  });

  if (copyButton) {
    copyButton.addEventListener('click', function () {
      var code = dialog.dataset.code;
      var done = function () {
        copyButton.textContent = 'Copied';
      };
      if (window.navigator.clipboard && window.navigator.clipboard.writeText) {
        window.navigator.clipboard.writeText(code).then(done, function () {});
      }
    });
  }

  /* Back from a normal form post (the captcha path): show the code straight away. */
  var params = new window.URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true' && read(PENDING)) {
    params.delete('customer_posted');
    var query = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
    showSuccess();
    return;
  }

  if (read(SUBSCRIBED)) return;

  var snoozedUntil = Number(read(SNOOZED_UNTIL)) || 0;
  if (snoozedUntil > Date.now()) return;

  /* Keep deferring for up to 5 minutes total if a dialog or a form keeps being in the
     way; past that, something is stuck open and we stop waiting rather than loop forever. */
  window.setTimeout(function () {
    openWhenClear(Date.now() + 5 * 60 * 1000);
  }, delay);
})();
